import React from 'react';

function PageDetails({ page }) {
  const { key, name, description } = page ?? {};

  return (
    key ? (
      <div
        id={`Page-${key}`}
        key={`Page-${key}`}
        className="page-details-item"
        data-testid={`Page-${key}`}
      >
        <h3 data-testid={`PageTitle-${key}`} className="page-details-title">
          {name}
        </h3>
        {description && (
          <p data-testid={`PageDescription-${key}`} className="page-details-description" title={description}>
            {description}
          </p>
        )}
      </div>
    ) : null
  );
}

export default PageDetails;
